if (!customElements.get("bundle-verification")) {
  class BundleVerification extends HTMLElement {
    constructor() {
      super();
      this.bundleVariants = [];
      this.handleAjaxCartEvent = this.handleAjaxCartEvent.bind(this);
    }

    connectedCallback() {
      this.parseBundleData();
      this.attachListeners();
      this.initialCheck();
    }

    disconnectedCallback() {
      document.removeEventListener("liquid-ajax-cart:request-end", this.handleAjaxCartEvent);
    }

    parseBundleData() {
      try {
        const raw = this.getAttribute("data-bundle-array");
        this.bundleVariants = raw ? JSON.parse(raw) : [];
      } catch (e) {
        console.error("Invalid bundle data JSON", e);
        this.bundleVariants = [];
      }
    }

    attachListeners() {
      document.addEventListener("liquid-ajax-cart:request-end", this.handleAjaxCartEvent);
    }

    async initialCheck() {
      const cart = await this.getCart();
      await this.checkBundlesInCart(cart);
    }

    async handleAjaxCartEvent() {
      const cart = await this.getCart();
      await this.checkBundlesInCart(cart);
    }

    async getCart() {
      const res = await fetch("/cart.js");
      return await res.json();
    }

    async updateBundleAttribute(cart, value) {
      if (!cart) return;

      const currentValue = cart.attributes?.is_it_bundle === true || cart.attributes?.is_it_bundle === "true";

      if (currentValue === value) return;

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            is_it_bundle: value
          }
        })
      });
    }

    async checkBundlesInCart(cart) {
    if (!cart || !cart.items || !this.bundleVariants.length) return;

    const isBundle = this.bundleVariants.some((bundle) =>
        bundle.every((sku) =>
        cart.items.some((item) => item.sku === sku && item.properties?._is_it_bundle === "true"))
    );

    await this.updateBundleAttribute(cart, isBundle);
    }

  }

  customElements.define("bundle-verification", BundleVerification);
}
